import { render, staticRenderFns } from "./createTaxAccountModal.vue?vue&type=template&id=d1f11394&scoped=true&"
import script from "./createTaxAccountModal.vue?vue&type=script&lang=js&"
export * from "./createTaxAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f11394",
  null
  
)

export default component.exports